/* eslint-disable import/no-unresolved */

import EpilogueMediumWoff from 'themes/fonts/Epilogue/EpilogueMedium.woff';
import EpilogueMediumWoff2 from 'themes/fonts/Epilogue/EpilogueMedium.woff2';

import EpilogueRegularWoff from 'themes/fonts/Epilogue/EpilogueRegular.woff';
import EpilogueRegularWoff2 from 'themes/fonts/Epilogue/EpilogueRegular.woff2';

import SFProRoundedMediumWoff from 'themes/fonts/SFProRounded/SFProRoundedMedium.woff';
import SFProRoundedMediumWoff2 from 'themes/fonts/SFProRounded/SFProRoundedMedium.woff2';

export const EpilogueMedium = `
@font-face {
  font-family: 'Epilogue';
  font-style: normal;
  font-display: swap;
  font-weight: 500;
  src: url(${EpilogueMediumWoff2}) format('woff2'), url(${EpilogueMediumWoff}) format('woff');
  unicode-range: U+0020-017F, U+20AC;
}
`;

export const EpilogueRegular = `
@font-face {
  font-family: 'Epilogue';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${EpilogueRegularWoff2}) format('woff2'), url(${EpilogueRegularWoff}) format('woff');
  unicode-range: U+0020-017F, U+20AC;
}
`;

export const SFProRoundedMedium = `
@font-face {
  font-family: 'SF Pro Rounded';
  font-style: normal;
  font-display: swap;
  font-weight: 500;
  src: url(${SFProRoundedMediumWoff2}) format('woff2'), url(${SFProRoundedMediumWoff}) format('woff');
  unicode-range: U+0020-017F, U+20AC;
}
`;

export function loadCustomFonts() {
  const style = document.createElement('style');
  style.innerHTML = `${EpilogueMedium}${EpilogueRegular}${SFProRoundedMedium}`;
  document.head.appendChild(style);
}
